<template>
<Card v-if="role">
  <p slot="title">{{ role.role }}</p>
  <p>
    <Card v-for="(module, key) in getModules()" :key="key">
          <p slot="title"><Icon type="ios-cube" /> {{ module.item }} ( {{ module.note }} )</p>
          <Row :gutter="16">
            <Col :span="12">
              <div class="auth-item-title">服务器端</div>
              <Col :span="8" v-for="(model, key) in groupItems(module.item, '2')" :key="key">
                <auth-item :model="model" ref="item" @refresh="fetchData"></auth-item>
              </Col>
            </Col>
            <Col :span="12">
              <div class="auth-item-title">前端</div>
              <Col :span="8" v-for="(model, key) in groupItems(module.item, '1')" :key="key">
                <auth-item :model="model" ref="item" @refresh="fetchData"></auth-item>
              </Col>
            </Col>
          </Row>
        </Card>
  </p>

</Card>
</template>

<script>
import { ListItemsByRole } from '@/api/auth'
import AuthItem from '@/components/auth/AuthItem'

export default {
  name: 'view-app',
  data: function () {
    return {
      role: null,
      items: [],
      showAddModule: false,
      showEditModule: false,
      showAddItem: false
    }
  },
  components: {
    'auth-item': AuthItem
  },
  created: function () {
    this.fetchData()
  },
  methods: {
    fetchData: function () {
      var role = this.$route.query.item
      console.log(role)
      ListItemsByRole(role).then(async res => {
        this.role = res.model
        this.items = res.items
      })
    },
    getModules: function (id) {
      return this.items.filter(function (item) {
        return item.type === '0'
      })
    },
    getSubItems: function (id) {
      return this.items.filter(function (item) {
        return item.parent_item === id
      })
    },
    groupItems: function (id, type) {
      return this.items.filter(function (item) {
        return item.parent_item === id && item.type === type
      })
    }
  }
}
</script>

<style>
.auth-item-title {
  font-weight: bold;
  padding: 5px 10px;
  border-bottom: 1px solid #d9dadb;
}
</style>
